/**
 * 教师中心 - 试卷上传页面
 *
 * 直接复用后台 PaperUpload 组件，通过 isTeacherMode 参数实现：
 * 1. 数据隔离（dataSource: 'teacher' → 写入 teacher_pending_papers）
 * 2. 布局差异（单页左右分栏 vs 后台两步向导）
 * 3. 分类来源（硬编码4分类 vs 后台动态 categoryStore）
 * 4. 主题色（紫色 vs 后台蓝色）
 * 5. 文件格式（统一仅支持 .docx）
 */

import PaperUpload from '../admin/PaperUpload';

export default function TeacherPaperUpload() {
  return <PaperUpload isTeacherMode={true} />;
}
